import Splide from '@splidejs/splide'

export function facts() {
	let items = 3
	let factSliders = []
	let height
	const elms = document.querySelectorAll('.splide--facts')

	const initSlider = () => {
		factSliders = []
		height = Math.max(...[...document.querySelectorAll('.projects-fact')].map((x) => x.offsetHeight))

		for (var i = 0; i < elms.length; i++) {
			factSliders.push(
				new Splide(elms[i], {
					perPage: items,
					perMove: 1,
					rewind: false,
					arrows: false,
					direction: 'ttb',
					height: `calc(${height * 1.05 * items}px + var(--item-gap))`,
					gap: 'var(--item-gap)',
				}).mount()
			)
		}
	}

	if (document.querySelector('.projects-facts')) {
		const resizeObserver = new ResizeObserver(() => {
			const banners = document.querySelectorAll('.section--projects-banner')

			banners.forEach((banner) => {
				if (banner.querySelector('.projects-facts')) {
					banner.style.setProperty('--factsSize', banner.querySelector('.projects-facts').clientHeight + 'px')

					if (banner.querySelectorAll('.banner__media').length == 1 || (banner.querySelector('.article-wrapper') && banner.querySelectorAll('.banner__media').length == 2)) {
						banner.style.paddingBottom = 'calc(var(--factsSize, 0px) / 2)'
					}
				}
			})

			if (window.innerWidth > 1024) {
				items = 3
			} else if (window.innerWidth > 768) {
				items = 2
			} else {
				items = 1
			}

			factSliders.forEach((slider) => {
				slider.destroy()
			})
			initSlider()
		})
		resizeObserver.observe(document.querySelector('body'))
	}
	return facts
}
